<!-- HEADER -->
<div class="modal-header border-0">
  <button
    type="button"
    class="btn-close"
    (click)="close()"
    [gptDataTrack]="dataTrackClose"
  >
    <i class="d-block gpicon-close"></i>
  </button>
</div>

<!-- CONTENT -->
<div class="full-image-modal-body custom-scroll-parent">
  <div
    #container
    *ngIf="viewHasInitialized"
    class="modal-body custom-scroll gp-0"
  >
    <div class="frame">
      <div class="h-100">
        <div class="h-100">
          <picture class="w-100">
            <source
              media="(min-width:769px)"
              [srcset]="bgImg + '_L.' + bgImageType"
            />
            <img class="h-100 w-100" [src]="bgImg + '_S.' + bgImageType" />
          </picture>
          <div class="gradient-background"></div>
        </div>
        <div class="content gpx-32 gpx-sm-72 gpb-40 gpb-sm-48">
          <p *ngIf="title" class="ct1-bold text-white gmb-8">
            {{ title | translate }}
          </p>
          <p *ngIf="description" class="cd1-regular text-white gmb-0">
            {{ description | translate }}
          </p>
          <button
            *ngIf="button"
            class="gbtn-red-4 gbtn-sq gmt-16 gmb-0"
            (click)="buttonClick.emit()"
            [gptDataTrack]="dataTrackClick"
          >
            {{ button | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
